import { CONTACT_INFO } from "../data/content";
import PrivacyPolicyDialog from "./PrivacyPolicyDialog";
import TermsDialog from "./TermsDialog";

const FOOTER_COLS = [
  {
    heading: "Studio",
    links: [
      { label: "About", href: "#about" },
      { label: "Process", href: "#process" },
      { label: "Careers", href: "#" },
      { label: "Journal", href: "#" },
    ],
  },
  {
    heading: "Practice",
    links: [
      { label: "Services", href: "#services" },
      { label: "Industries", href: "#industries" },
      { label: "Process", href: "#process" },
      { label: "Blog", href: "#" },
    ],
  },
  {
    heading: "Legal",
    links: [
      { label: "Privacy Policy", type: "privacy" },
      { label: "Terms & Conditions", type: "terms" },
      { label: "Contact", href: "#contact" },
      { label: "Press", href: "#" },
    ],
  },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#1C1917] text-white pt-24 pb-10 overflow-hidden"
    >
      <div className="max-w-[90rem] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 pb-16 border-b border-white/10">
          <div className="lg:col-span-5">
            <p className="overline text-stone-400 mb-6">The Studio</p>
            <p className="font-serif-display text-3xl leading-snug text-white max-w-md">
              Bespoke surfaces, curated for people who understand that
              interiors are a form of authorship.
            </p>
            <div className="mt-8 text-sm text-stone-400 space-y-1">
              <p>{CONTACT_INFO.address}</p>
              <p>{CONTACT_INFO.email} · {CONTACT_INFO.phone}</p>
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 md:grid-cols-3 gap-8">
            {FOOTER_COLS.map((col) => (
              <div key={col.heading}>
                <p className="overline text-stone-400 mb-4">{col.heading}</p>
                <ul className="space-y-3">
                  {col.links.map((l) => (
                    <li key={l.label}>
                      {l.type === "privacy" ? (
                        <PrivacyPolicyDialog
                          trigger={
                            <button
                              data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                              className="link-underline text-sm text-stone-200 hover:text-white text-left"
                            >
                              {l.label}
                            </button>
                          }
                        />
                      ) : l.type === "terms" ? (
                        <TermsDialog
                          trigger={
                            <button
                              data-testid={`footer-link-${l.label.toLowerCase().replace(/[&\s]+/g, "-").replace(/-+/g, "-")}`}
                              className="link-underline text-sm text-stone-200 hover:text-white text-left"
                            >
                              {l.label}
                            </button>
                          }
                        />
                      ) : (
                        <a
                          href={l.href}
                          data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                          className="link-underline text-sm text-stone-200 hover:text-white"
                        >
                          {l.label}
                        </a>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom row */}
        <div className="pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-stone-400">
          <p>© {new Date().getFullYear()} VARNELLA Studio. All rights reserved.</p>
          <p className="uppercase tracking-[0.25em] text-[10px] text-stone-300">
            Brand by VR Custom Solutions LLP.
          </p>
          <p className="uppercase tracking-[0.25em] text-[10px]">
            Crafted in Chennai
          </p>
        </div>
      </div>
    </footer>
  );
}
